module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "completeLicense"
  }, [_c('h1', [_vm._v("Complete License")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.licenseRecordData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "outerlicense",
      "label": "Outer License"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "interlicense",
      "label": "Inter License"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "er_num",
      "label": "ER Number",
      "formatter": _vm.arrayFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "license_content",
      "label": "License Content",
      "formatter": _vm.jsonFormat
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "project",
      "label": "Project Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "direct_cus",
      "label": "Direct Customer"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "user_email",
      "label": "Customer Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "exp_date",
      "label": "Expiry Date [as UTC(+00:00)]",
      "formatter": _vm.dateFormat
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "welcome"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "plain": ""
    }
  }, [_vm._v("OK")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "loading": _vm.downloading
    },
    on: {
      "click": function($event) {
        return _vm.onClick()
      }
    }
  }, [_vm._v("DownLoad"), _c('i', {
    staticClass: "el-icon-download el-icon--right"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5836ac1e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompleteLicense.vue
// module id = uH2m
// module chunks = 1